import MarketingLayout from "@/components/MarketingLayout";
import { Button } from "@/components/ui/button";
import { Home, Search } from "lucide-react";
import { useLocation } from "wouter";

export default function NotFound() {
  const [, setLocation] = useLocation();

  return (
    <MarketingLayout>
      <section className="container py-20 flex flex-col items-center text-center">
        <div className="w-20 h-20 rounded-2xl bg-primary flex items-center justify-center mb-8">
          <span className="text-primary-foreground font-bold text-4xl font-mono">
            OO
          </span>
        </div>

        <h1 className="text-6xl sm:text-8xl font-bold text-foreground mb-4 tracking-tight">
          404
        </h1>

        <h2 className="text-xl sm:text-2xl font-semibold text-muted-foreground mb-4">
          Page Not Found
        </h2>

        <p className="text-muted-foreground mb-10 max-w-md leading-relaxed">
          The page you're looking for doesn't exist or has been moved.
          Let's get you back on track.
        </p>

        <div className="flex flex-col sm:flex-row gap-3">
          <Button onClick={() => setLocation("/")} size="lg">
            <Home className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
          <Button
            variant="outline"
            size="lg"
            onClick={() => setLocation("/docs")}
          >
            <Search className="w-4 h-4 mr-2" />
            Browse Docs
          </Button>
        </div>
      </section>
    </MarketingLayout>
  );
}
